module.exports = __webpack_public_path__ + "static/media/img9.8264e245.png";